import { ThirdPartyLogApplication } from 'onboarding/classes/models/thirdPartyLog'

const APPLICATION_NAMES = {
  [ThirdPartyLogApplication.Securimate]: 'Securimate',
  [ThirdPartyLogApplication.Exiger]: 'Exiger',
  [ThirdPartyLogApplication.ICertis]: 'ICertis',
  [ThirdPartyLogApplication.Portal]: 'Portal',
  [ThirdPartyLogApplication.Apollo]: 'Apollo',
}

export const getReadableTabName = (application: ThirdPartyLogApplication) => {
  return APPLICATION_NAMES[application] || 'Unknown'
}
